import { ref, onMounted, onUnmounted } from 'vue';

export function useTabVisibility() {
  const isTabVisible = ref(true);
  const showInactivityModal = ref(false);
  const hiddenTimestamp = ref<number | null>(null);
  
  // Show the welcome-back modal after 10 minutes away from the app.
  const INACTIVITY_THRESHOLD = 10 * 60 * 1000;

  const handleVisibilityChange = () => {
    if (document.hidden) {
      // Tab is now hidden
      isTabVisible.value = false;
      hiddenTimestamp.value = Date.now();
    } else {
      // Tab is now visible again
      isTabVisible.value = true;
      
      // Check how long the user was away
      if (hiddenTimestamp.value) {
        const timeAway = Date.now() - hiddenTimestamp.value;
        
        if (timeAway >= INACTIVITY_THRESHOLD) {
          // User was away for too long, show the modal
          showInactivityModal.value = true;
        }
      }
      
      hiddenTimestamp.value = null;
    }
  };

  const closeInactivityModal = () => {
    showInactivityModal.value = false;
    hiddenTimestamp.value = null;
  };

  onMounted(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
  });

  onUnmounted(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  });

  return {
    isTabVisible,
    showInactivityModal,
    closeInactivityModal
  };
}
